import { useUserRole } from "@/hooks/useUserRole";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Activity, Database, Shield, Users } from "lucide-react";

export function StatusGrid() {
  const { isAdmin, loading } = useUserRole();

  if (loading) {
    return (
      <div className="grid gap-2.5 md:grid-cols-2 lg:grid-cols-3">
        <div className="animate-pulse bg-muted/30 rounded-lg h-32"></div>
        <div className="animate-pulse bg-muted/30 rounded-lg h-32"></div>
        <div className="animate-pulse bg-muted/30 rounded-lg h-32"></div>
      </div>
    );
  }

  if (!isAdmin()) {
    return null;
  }

  return (
    <div className="grid gap-2.5 md:grid-cols-1 lg:grid-cols-1">
    <Card className="min-h-[140px] flex flex-col">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium flex items-center gap-2">
          <Activity className="h-4 w-4 text-primary" />
          System Status
        </CardTitle>
      </CardHeader>
      <CardContent className="flex-1">
        <div className="space-y-2 h-full flex flex-col justify-between">
          <div className="flex items-center gap-2">
            <Activity className="w-6 h-6 text-primary" />
            <div className="text-2xl font-bold text-primary">Online</div>
          </div>
          <div className="text-xs text-muted-foreground">
            System operational and responsive
          </div>
          <div className="flex justify-between text-xs border-t pt-2">
            <span className="text-muted-foreground">Uptime</span>
            <span className="font-medium">45d 12h</span>
          </div>
        </div>
      </CardContent>
    </Card>
    </div>
  );
}